export default {
  index:'首页',
  groupInfo:{
    title:'集团信息',
    recommend:{
      name:'集团介绍',
      desc:'润人于斯，润歌于行'
    },
    history:{
      name:'发展历程',
      desc:'扶摇直上，砥砺前行'
    },
    culture:{
      name:'企业文化',
      desc:'人本、团队、责任、健康'
    },
    honor:{
      name:'集团荣誉',
      desc:'荣誉来自认可'
    },
  },
  spread:{
    title:'业务体系',
    goods:{
      name:'虚拟商品采购及交付',
      desc:'专业的团队及契约精神'
    },
    advert:{
      name:'推广及广告服务',
      desc:'信息流广告实现三方共赢'
    },
    game:{
      name:'手游/软件开发及维护',
      desc:'手机游戏及软件开发及维护服务'
    },
    lottery:{
      name:'一站式彩票解决方案',
      desc:'彩票软件系统及设备解决方案'
    },
  },
  marketing:{
    title:'营销服务平台',
    platform_0:{
      name:'互娱权益平台',
      desc:'一站式权益采购平台'
    },
    platform_1:{
      name:'广告营销平台',
      desc:'智能广告营销平台'
    },
    platform_2:{
      name:'SaaS服务平台',
      desc:'信息化管理运营解决方案'
    },
  },
  investor:{
    title:'投资者关系',
    noContent:'暂无内容',
    details:'详情',
    back:'返回',
    loading:'加载中...',
    notice:{
      name:'公司通告',
      desc:'全程参与严格监督',
      files:{
        flie0:'正式通告',
        flie1:'组织章程细则',
        flie2:'会计师报告',
        flie3:'经审计合并财务报表',
        flie4:'衡力斯律师事务所编制的意见函',
        flie5:'开曼公司法',
        flie6:'中国法律意见书',
        flie7:'行业报告',
        flie8:'服务合同及委任函',
        flie9:'重大合约',
        flie10:'专家同意书',
        flie11:'公司章程',
        flie12:'审核委员会的职权范围',
        flie13:'薪酬委员会的职权范围',
        flie14:'提名委员会的职权范围',
        flie15:'董事名单与其角色及职能',
        flie16:'股东提名候选董事的程序',
        flie17:'股东通讯政策',
      }
    },
    file:{
      name:'招股文件',
      desc:'深入了解精准分析',
      files:{
        flie0:'全球发售',
        flie1:'申请表',
        flie2:'发售价及配发结果公告',
      }
    },
    report:{
      name:'定期报告',
      desc:'公开透明及时准确',
      files:{
        flie0:'月报表 - 截至2022年10月31日止股分发行人的证券变动月报表',
      }
    },
    news:{
      name:'公司新闻',
      desc:'实时关注掌握动态'
    },
    telephone:{
      name:'投资者热线',
      desc:'竭诚服务欢迎联系',
      address:'杭州市富阳区银湖街道银溪路77号润歌互动总部大厦19楼'
    },
  },
  aboutUs:{
    title:'关于我们',
    contact:{
      name:'联系我们',
      desc:'提供专业、优质的服务'
    },
    join:{
      name:'招贤纳士',
      desc:'伯乐寻才，广纳精英'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js